import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'semantic-ui-react'

export default function LanguageSelector({ value, onChange, options, disabled }) {
  const dropdownOptions = options
    .map((option) => {
      const status = option.isDefault ? 'Default' : option.isActive === false ? 'Inactive' : null
      return {
        key: option.value,
        value: option.value,
        text: option.name,
        content: (
          <div className="flex items-center justify-between gap-2 whitespace-normal">
            <span>{option.name}</span>
            {status && <span className="text-grey flex-none">{status}</span>}
          </div>
        ),
      }
    })
    .sort((a, b) => a.text.localeCompare(b.text))

  return (
    <Dropdown
      selection
      data-testid="language-selector"
      className="min-w-44"
      value={value}
      disabled={disabled}
      onChange={(_, { value: nextValue }) => onChange(nextValue)}
      options={dropdownOptions}
    />
  )
}

LanguageSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isDefault: PropTypes.bool,
      isActive: PropTypes.bool,
    })
  ).isRequired,
  disabled: PropTypes.bool,
}

LanguageSelector.defaultProps = {
  disabled: false,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LanguageSelector/index.js